import { t } from "i18next";
import { toast } from "@/hooks/use-toast";
import { stripMarkdown } from "@/lib/plainText";
import { stripVerifyMarkers } from "@/lib/verifyMarkers";

// The note's "[verify]" markers are resolved in the review step before these
// run (workspace/VerifyReview.tsx), so the copied text never carries one. The
// markers are stripped here too, so a marker can never reach the EMR.

// Copies a note as plain text (for pasting into the EMR) and confirms it
// (with `message`, or the generic "copied to your clipboard"). True once it
// is on the clipboard.
export const copyNoteToClipboard = async (
  text: string | null | undefined,
  message?: string,
): Promise<boolean> => {
  if (text != null) {
    try {
      await navigator.clipboard.writeText(
        stripMarkdown(stripVerifyMarkers(text)),
      );
      toast({
        variant: "default",
        description: message ?? t("visits.templateViewer.messages.textCopied"),
        duration: message ? 1500 : 1000,
      });
      return true;
    } catch {
      // silent fail
    }
  }
  return false;
};

// Copies one section of a note (e.g. Subjective) as plain text, without its
// heading line, for an EMR with a separate field per section.
export const copySectionToClipboard = async (
  body: string,
  name: string,
): Promise<void> => {
  try {
    await navigator.clipboard.writeText(
      stripMarkdown(stripVerifyMarkers(body)),
    );
    toast({
      variant: "default",
      description: t("visit.workspace.sectionCopied", { name }),
      duration: 1500,
    });
  } catch {
    // silent fail, as for the whole note
  }
};
